import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { DuplicatePair } from "@mapmycustomers/shared/types/entity/Duplicate";
import { Alert } from "@mapmycustomers/ui";

import { getSelectedPair } from "@app/scene/settings/component/MergeDuplicates/store";
import { RootState } from "@app/store/rootReducer";
import { getDuplicateReasonDisplayName } from "@app/util/ui";

interface Props {
  pair?: DuplicatePair;
}

const DupeReason: React.FC<Props> = ({ pair }) => {
  const intl = useIntl();
  return (
    <div>
      <Alert
        message={intl.formatMessage(
          {
            id: "settings.mergeDuplicates.previewMergePane.duplicateReasons",
            defaultMessage: "Duplicate Values: {reasons}",
            description: "Settings Merge duplicates - preview/merge pane - duplicate reasons",
          },
          {
            reasons:
              pair?.dupeReason
                .map((reason) => getDuplicateReasonDisplayName(intl, reason))
                .sort((name1, name2) => name1.localeCompare(name2))
                .join(", ") ?? "",
          }
        )}
        showIcon
        type="info"
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  pair: getSelectedPair(state),
});

export default connect(mapStateToProps)(DupeReason);
